/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface StaticPageNestedCalculator
 */
export interface StaticPageNestedCalculator {
  /**
   *
   * @type {number}
   * @memberof StaticPageNestedCalculator
   */
  readonly id: number
  /**
   *
   * @type {any}
   * @memberof StaticPageNestedCalculator
   */
  structure?: any | null
}

/**
 * Check if a given object implements the StaticPageNestedCalculator interface.
 */
export function instanceOfStaticPageNestedCalculator(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function StaticPageNestedCalculatorFromJSON(json: any): StaticPageNestedCalculator {
  return StaticPageNestedCalculatorFromJSONTyped(json, false)
}

export function StaticPageNestedCalculatorFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StaticPageNestedCalculator {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    structure: !exists(json, 'structure') ? undefined : json['structure'],
  }
}

export function StaticPageNestedCalculatorToJSON(value?: StaticPageNestedCalculator | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    structure: value.structure,
  }
}
